import React, { useState } from "react";
import "./Hero.css";
import "../../index.css";
import api from "../../api/Createapi.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import { Zap, Home, RefreshCw } from "lucide-react";

function Hero() {
    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        email: "",
        city: "Achampet",
        address: "",
        pincode: ""
    });

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await api.post("/addUser.php", formData);

            if (response.data.status === "success") {
                toast.success("Submitted Successfully!");
                setFormData({
                    name: "",
                    mobile: "",
                    email: "",
                    city: "Achampet",
                    address: "",
                    pincode: ""
                });
            }
        } catch (error) {
            console.error(error);
            toast.error("Server error");
        }
        finally {
            setLoading(false);
        }
    };
    return (
        <section className="hero">
            {loading && <Loader />}
            <div className="hero-header-box">
                <h1 className="hero-title">Digital TV & Internet in Achampet</h1>
                <p className="hero-subtitle">Superfast fiber connection with unlimited entertainment combos</p>
            </div>

            <div className="hero-content">
                <div className="hero-image">
                    <ul className="feature-list">
                        <li className="feature-item">
                            <div className="feature-icon"><Zap size={24} color="#ff8a00" /></div>
                            <div>
                                <strong>Committed Speed</strong><br />
                                <span>on Wi-Fi Router</span>
                            </div>
                        </li>

                        <li className="feature-item">
                            <div className="feature-icon"><Home size={24} color="#ff8a00" /></div>
                            <div>
                                <strong>100% Fiber</strong><br />
                                <span>to Home</span>
                            </div>
                        </li>

                        <li className="feature-item">
                            <div className="feature-icon"><RefreshCw size={24} color="#ff8a00" /></div>
                            <div>
                                <strong>Same Upload &</strong><br />
                                <span>Download Speed</span>
                            </div>
                        </li>
                    </ul>

                    <div className="price-tag">PLANS STARTING ₹499*</div>
                </div>

                <div className="hero-form" id="contactFormSection">
                    <h3>
                        Step into the world of high-speed connectivity
                    </h3>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <input
                                type="text"
                                id="name"
                                placeholder="Name*"
                                style={{ textTransform: "capitalize" }}
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <input
                                type="tel"
                                id="mobile"
                                placeholder="Mobile No.*"
                                value={formData.mobile}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="email"
                                id="email"
                                placeholder="Email*"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
                            <select
                                id="city"
                                value={formData.city}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select City</option>
                                <option value="Achampet">Achampet</option>
                                <option value="Hyderabad">Hyderabad</option>
                                <option value="Nagarkurnool">Nagarkurnool</option>
                                <option value="Kalwakurthy">Kalwakurthy</option>
                            </select>
                            <input
                                type="text"
                                id="pincode"
                                placeholder="PIN Code"
                                value={formData.pincode}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <textarea
                                id="address"
                                placeholder="Address*"
                                value={formData.address}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        {/* <div className="form-group">
                            <input
                                type="text"
                                id="pincode"
                                placeholder="PIN Code"
                                value={formData.pincode}
                                onChange={handleChange}
                                required
                            />
                        </div> */}

                        <p className="terms">
                            By submitting details you agree to our{" "}
                            <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
                        </p>

                        <button type="submit" className="submit-btn">
                            SUBMIT
                        </button>
                    </form>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </section>
    );
}

export default Hero;
